/* eslint-disable no-nested-ternary */
/**
 * @name Home
 * @description Componente del dashboard home
 * @author César Rivera
 */

import React, { PureComponent } from 'react';
import i18n from 'i18next';
import { trackPromise } from 'react-promise-tracker';
import styled from 'styled-components';

import { LoadingWrapper, NoticesSidebar } from '@components';
import { EmployeeService, ResponseHandlerService, /* PreviousRouteService */ } from '@services';
import { Card, Flex, Layout, MUI, Typography } from '@styles';

// Components
import Birthdays from './components/birthdays';
import Carousel from './components/carousel';
import EmployeesGraph from './components/employees-graph';
import News from './components/news';
import WorkAnniversaries from './components/work-anniversaries';

// Dialogs
import BirthdaysDialog from './dialogs/birthdays.dialog';
import WorkAnniversariesDialog from './dialogs/work-anniversaries.dialog';

class Home extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      // companyId: '',
      companyName: '',
      companyLogo: '',
      companyDescription: '',
      // companyRelease: '',
      companyImages: [],
      companyMission: '',
      companyVision: '',
      companyValues: [],
      companyGoals: [],
      titleMission: '',
      titleVision: '',
      titleValues: '',
      titleGoals: '',
      birthdaysInfo: [],
      birthdaysDialog: false,
      workAnniversariesInfo: [],
      workAnniversariesDialog: false,
      noticesSideBar: [],
      open: localStorage.getItem('sidebarOpen') === 'true', // Conversión a booleano
    };
  }

  componentDidMount() {
    this.getCompanyInfo();
    // JSON.parse(localStorage.getItem('ls.URLToRedirect')) ? PreviousRouteService.cleanPreviousRoute() : null;
  }

  getCompanyInfo = () => {
    trackPromise(
      EmployeeService.getInfo()
        .then((response) => {
          this.setState({
            employeeName: response.Empleado.Nombres,
            // companyId: response.Empresa.IdEmpresa,
            companyName: response.Empresa.Empresa,
            companyLogo: response.Empresa.Logo,
            companyDescription: response.Empresa.Descripcion,
            // companyRelease: response.Empresa.Comunicado,
            companyImages: response.ImagenesCarrusel.filter((element) => element.URL !== ''),
            companyMission: response.CulturaEmpresa.find((element) => element.Concepto === 'Mision') || '',
            companyVision: response.CulturaEmpresa.find((element) => element.Concepto === 'Vision') || '',
            companyValues: response.CulturaEmpresa.filter((element) => element.Concepto === 'Valor'),
            companyGoals: response.CulturaEmpresa.filter((element) => element.Concepto === 'Objetivo'),
            titleMission: response.TitulosCulturaEmpresa.TituloMision,
            titleVision: response.TitulosCulturaEmpresa.TituloVision,
            titleValues: response.TitulosCulturaEmpresa.TituloValores,
            titleGoals: response.TitulosCulturaEmpresa.TituloObjetivos,
            employeesMan: response.Empresa.Masculino,
            employeesWoman: response.Empresa.Femenino,
            birthdaysInfo: response.EmpleadoCumpleanios,
            workAnniversariesInfo: response.EmpleadoAniversario,
            showGraphEmployees: response.Empresa.GraficaVisible,
            showBirthdaysMonth: response.Empresa.CumpleaniosVisible,
            showAnniversariesMonth: response.Empresa.AniversariosVisible,
            noticesSideBar: response.BarraLateral
          });
        }).catch((error) => {
          ResponseHandlerService.error(error);
        }),
      'loading-home'
    );
  }

  openDialog = (dialog) => {
    switch (dialog) {
      case 'birthdays':
        this.setState({ birthdaysDialog: true });
        break;
      case 'workAnniversaries':
        this.setState({ workAnniversariesDialog: true });
        break;
      default:
        break;
    }
  }

  closeDialog = (dialog) => {
    switch (dialog) {
      case 'birthdays':
        this.setState({ birthdaysDialog: false });
        break;
      case 'workAnniversaries':
        this.setState({ workAnniversariesDialog: false });
        break;
      default:
        break;
    }
  }

  // Maneja el cambio de estado del sidebar y guarda el valor en localStorage
  drawerToggleHandler = () => {
    this.setState((prevState) => {
      const newOpenState = !prevState.open;
      localStorage.setItem('sidebarOpen', newOpenState); // Guardar el nuevo estado en localStorage
      return { open: newOpenState };
    });
  }

  render() {
    const {
      employeeName,
      // companyId,
      companyName,
      companyLogo,
      companyDescription,
      // companyRelease,
      companyImages,
      companyMission,
      companyVision,
      companyValues,
      companyGoals,
      titleMission,
      titleVision,
      titleValues,
      titleGoals,
      employeesMan,
      employeesWoman,
      birthdaysInfo,
      birthdaysDialog,
      workAnniversariesInfo,
      workAnniversariesDialog,
      showGraphEmployees,
      showBirthdaysMonth,
      showAnniversariesMonth,
      open,
      noticesSideBar
    } = this.state;

    return (
      <LoadingWrapper area={'loading-home'}>
        <Layout.Title>
          <Flex.Row>
            <Flex.Col>
              <Typography.H4 color="blueMedium">
                {`${i18n.t('GenericMessages.hello')}, `}
                <EmployeeName>{employeeName}</EmployeeName>
                {'!'}
              </Typography.H4>
              <Typography.Small>{i18n.t('GenericMessages.niceToHaveYouBack')}</Typography.Small>
            </Flex.Col>
            <WelcomeImg src="https://assets.talentry.io/icons/reconocimientos/aunporreconocer.png" />
          </Flex.Row>
        </Layout.Title>

        {/* Drawer Lateral - Noticias */}
        {(noticesSideBar && Object.keys(noticesSideBar).length > 0) && (
          <NoticesSidebar
            open={open}
            notices={noticesSideBar}
            toggleHandler={this.drawerToggleHandler} // Pasamos la función correctamente
          />
        )}

        <Layout.Content style={{ padding: '16px 8px' }}>
          <MUI.Grid container spacing={4}>
            <MUI.Grid container item spacing={4}>
              {/* Logo Empresa */}
              {companyLogo && (
                <MUI.Grid item md={3} sm={4} xs={12}>
                  <Card.Paper height={170}>
                    <CompanyLogoImg url={companyLogo}></CompanyLogoImg>
                  </Card.Paper>
                </MUI.Grid>
              )}
              {/* Empresa & Misión */}
              <MUI.Grid item md={companyLogo ? 9 : 12} sm={companyLogo ? 8 : 12} xs={12}>
                <Card.Paper height={170}>
                  <Card.Header>
                    <Card.HeaderTitle>
                      <CompanyName>{companyName}</CompanyName>
                    </Card.HeaderTitle>
                  </Card.Header>
                  <Card.Content>
                    {companyMission.length !== 0 && (
                      <>
                        {/* PROPÓSITO - KPMG (ID: 93) & HOLCIM (ID: 51) */}
                        {/* {(companyId === 93 || companyId === 51 || companyId === 1126) && <Typography.H6 style={{ padding: '0 8px' }}>{i18n.t('Home.purpose')}</Typography.H6>} */}
                        {/* MISION */}
                        {/* {(companyId !== 93 && companyId !== 51 || companyId === 1126) && <Typography.H6 style={{ padding: '0 8px' }}>{i18n.t('Home.mission')}</Typography.H6>} */}
                        <Typography.H6 style={{ padding: '0 8px' }}>{titleMission !== 'Misión' ? titleMission : i18n.t('Home.mission')}</Typography.H6>
                        <Flex.Row padding="8px">
                          <Typography.Text>{companyMission.Descripcion}</Typography.Text>
                        </Flex.Row>
                      </>
                    )}
                    {companyDescription !== '' && companyMission.length === 0 && (
                      <Flex.Row padding="8px">
                        <Typography.Text>{companyDescription}</Typography.Text>
                      </Flex.Row>
                    )}
                  </Card.Content>
                </Card.Paper>
              </MUI.Grid>
            </MUI.Grid>

            {/* Cultura Empresa */}
            {(companyVision.length !== 0 || companyValues.length !== 0 || companyGoals.length !== 0) && (
              <MUI.Grid container item spacing={4}>
                {/* Visión */}
                {(companyVision.length !== 0 && (
                  <MUI.Grid item
                    md={(companyValues.length !== 0 && companyGoals.length !== 0) ? 4 : (companyValues.length !== 0 || companyGoals.length !== 0) ? 6 : 12}
                    sm={(companyValues.length !== 0 && companyGoals.length !== 0) ? 6 : (companyValues.length !== 0 || companyGoals.length !== 0) ? 6 : 12}
                    xs={12}
                  >
                    <CompanyCard height={150}>
                      <CompanyCardContent>
                        <CompanyCardHeader>
                          <Typography.H6>{titleVision !== 'Visión' ? titleVision : i18n.t('Home.vision')}</Typography.H6>
                        </CompanyCardHeader>
                        <Flex.Row padding="8px">
                          <Typography.Text>{companyVision.Descripcion}</Typography.Text>
                        </Flex.Row>
                      </CompanyCardContent>
                      <ImageBackground>
                        <Image src="https://assets.talentry.io/icons/reconocimientos/reconocidoami.png" />
                      </ImageBackground>
                    </CompanyCard>
                  </MUI.Grid>
                ))}
                {/* Valores */}
                {companyValues.length !== 0 && (
                  <MUI.Grid item
                    md={(companyVision.length !== 0 && companyGoals.length !== 0) ? 4 : (companyVision.length !== 0 || companyGoals.length !== 0) ? 6 : 12}
                    sm={(companyVision.length !== 0 && companyGoals.length !== 0) ? 6 : (companyVision.length !== 0 || companyGoals.length !== 0) ? 6 : 12}
                    xs={12}
                  >
                    <CompanyCard height={150}>
                      <CompanyCardContent>
                        <CompanyCardHeader>
                          {/* PRINCIPIOS - DIFOSO (ID: 1112) */}
                          {/* {companyId === 1112 && <Typography.H6>{i18n.t('Home.principles')}</Typography.H6>} */}
                          {/* VALORES */}
                          {/* {companyId !== 1112 && <Typography.H6>{i18n.t('Home.values')}</Typography.H6>} */}
                          <Typography.H6>{titleValues !== 'Valores' ? titleValues : i18n.t('Home.values')}</Typography.H6>
                        </CompanyCardHeader>
                        <Flex.Col padding="8px">
                          {companyValues.length === 1 ? (
                            <Typography.Text>{companyValues[0].Descripcion}</Typography.Text>
                          ) : (
                            companyValues.map((value, index) => (
                              <BoxItem key={index}>
                                <BoxIconDot>●</BoxIconDot>
                                <Typography.Text>{value.Descripcion}</Typography.Text>
                              </BoxItem>
                            ))
                          )}
                        </Flex.Col>
                      </CompanyCardContent>
                      <ImageBackground>
                        <Image src="https://assets.talentry.io/icons/reconocimientos/aunporreconocer.png" style={{ transform: 'scaleX(-1)' }} />
                      </ImageBackground>
                    </CompanyCard>
                  </MUI.Grid>
                )}
                {/* Objetivos */}
                {(companyGoals.length !== 0) && (
                  <MUI.Grid item
                    md={(companyVision.length !== 0 && companyValues.length !== 0) ? 4 : (companyVision.length !== 0 || companyValues.length !== 0) ? 6 : 12}
                    sm={(companyVision.length !== 0 && companyValues.length !== 0) ? 6 : (companyVision.length !== 0 || companyValues.length !== 0) ? 6 : 12}
                    xs={12}
                  >
                    <CompanyCard height={150}>
                      <CompanyCardContent>
                        <CompanyCardHeader>
                          {/* ATRIBUTOS - KPMG (ID: 93) */}
                          {/* {companyId === 93 && <Typography.H6>{i18n.t('Home.attributes')}</Typography.H6>} */}
                          {/* OBJETIVOS */}
                          {/* {companyId !== 93 && <Typography.H6>{i18n.t('Home.goals')}</Typography.H6>} */}
                          <Typography.H6>{titleGoals !== 'Objetivos' ? titleGoals : i18n.t('Home.goals')}</Typography.H6>
                        </CompanyCardHeader>
                        <Flex.Col padding="8px">
                          {companyGoals.length === 1 ? (
                            <Typography.Text>{companyGoals[0].Descripcion}</Typography.Text>
                          ) : (
                            companyGoals.map((goal, index) => (
                              <BoxItem key={index}>
                                <BoxIconDot>●</BoxIconDot>
                                <Typography.Text>{goal.Descripcion}</Typography.Text>
                              </BoxItem>
                            ))
                          )}
                        </Flex.Col>
                      </CompanyCardContent>
                      <ImageBackground>
                        <Image src="https://assets.talentry.io/icons/reconocimientos/reconocidopormi.png" style={{ transform: 'scaleX(-1)' }} />
                      </ImageBackground>
                    </CompanyCard>
                  </MUI.Grid>
                )}
              </MUI.Grid>
            )}

            <MUI.Grid container item spacing={4}>
              {/* Carousel de Fotos */}
              <MUI.Grid item md={6} sm={12} xs={12}>
                <Carousel items={companyImages} />
              </MUI.Grid>

              {/* Avisos */}
              <MUI.Grid item md={6} sm={12} xs={12}>
                <Card.Paper height={432}>
                  <News />
                </Card.Paper>
              </MUI.Grid>
            </MUI.Grid>

            <MUI.Grid container item spacing={4}>
              {/* Colaboradores */}
              {showGraphEmployees && (
                <MUI.Grid item md={4} sm={6} xs={12}>
                  <Card.Paper height={300}>
                    <EmployeesGraph
                      man={employeesMan}
                      woman={employeesWoman}
                    />
                  </Card.Paper>
                </MUI.Grid>
              )}

              {/* Cumpleaños */}
              {showBirthdaysMonth && (
                <MUI.Grid item md={4} sm={6} xs={12}>
                  <Card.Paper height={300}>
                    <Birthdays
                      birthdays={birthdaysInfo}
                      onOpen={() => this.openDialog('birthdays')}
                    />
                  </Card.Paper>
                </MUI.Grid>
              )}

              {/* Aniversarios Laborales */}
              {showAnniversariesMonth && (
                <MUI.Grid item md={4} sm={6} xs={12}>
                  <Card.Paper height={300}>
                    <WorkAnniversaries
                      anniversaries={workAnniversariesInfo}
                      onOpen={() => this.openDialog('workAnniversaries')}
                    />
                  </Card.Paper>
                </MUI.Grid>
              )}
            </MUI.Grid>
          </MUI.Grid>
        </Layout.Content>

        {/* Modal de todos los cumpleaños */}
        {birthdaysDialog ? (
          <BirthdaysDialog
            birthdays={birthdaysInfo}
            open={birthdaysDialog}
            onClose={() => this.closeDialog('birthdays')}
          />
        ) : null}

        {/* Modal de todos los aniversarios laborales */}
        {workAnniversariesDialog ? (
          <WorkAnniversariesDialog
            anniversaries={workAnniversariesInfo}
            open={workAnniversariesDialog}
            onClose={() => this.closeDialog('workAnniversaries')}
          />
        ) : null}
      </LoadingWrapper>
    );
  }
}

// *************************************
// STYLED COMPONENTS                               
// *************************************

const EmployeeName = styled.span`
  font-family: 'Bryant Pro Medium';
  font-size: ${(props) => props.theme.typography.heading4};
  color: ${(props) => props.theme.colors.greyDark};
`;

const CompanyName = styled.span`
  font-family: 'Bryant Pro Bold';
  font-size: ${(props) => props.theme.typography.heading2};
  color: ${(props) => props.theme.colors.greyDark};
`;

const WelcomeImg = styled.img`
  width: 40px;
  height: 40px;
  transform: scaleX(-1);
`;

const CompanyLogoImg = styled.div`
  width: 100%;
  height: 100%;
  background-image: url(${(props) => props.url});
  background-size: cover;
  background-position: center;
  border-radius: 6px;
`;

const BoxItem = styled.div`
  display: flex;
  align-items: center;
  padding-bottom: 8px;
  &:last-child { padding-bottom: 0px; }
`;

const BoxIconDot = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 20px;
  margin-right: 12px;
`;

const CompanyCard = styled(Card.Paper)`
  position: relative;
  padding: 0px;
  overflow: hidden;
`;

const CompanyCardContent = styled(Flex.Col)`
  height: 100%;
  padding: 8px;
  padding-right: 32px;
  overflow-y: auto;
  scrollbar-width: thin !important; // Scrollbar Firefox
`;

const CompanyCardHeader = styled(Flex.Row)`
  padding: 8px 8px 0 8px;
`;

const ImageBackground = styled.div`
  position: absolute;
  right: -24px;
  bottom: -32px;
  z-index: -1;
  opacity: 0.6;
`;

const Image = styled.img`
  height: 120px;
  width: 120px;
  //transform: scaleX(-1)
`;

export default Home;